import React from 'react';
import Header from './Component/Header/Header';
import './App.css';
import Registeration from './Component/Main/Registeration/Registeration';

const App = () => {
  return (
    <>
      <Header/>
      <Registeration/>
    </>
  )
}

export default App